const appConfig = {
  "name": "voip-v2-test",
  "version": "0.1.0",
  "stage": "test",
  "deployThisBuild": false,
  "okta": {
    "issuer": "https://okta.mit.edu/oauth2/aus6shd5478WH30vd697",
    "clientId": "7iapvj75crn79593bjgphgfdog",
    "redirectUris": [
      "https://voip-v2-test.atlas-apps-test.mit.edu"
    ],
    "postLogoutRedirectUris": [
      "https://voip-v2-test.atlas-apps-test.mit.edu/logout"
    ],
    "scopes": [
      "digital-id/search",
      "digital-id/user",
      "openid",
      "profile",
      "voip/user"
    ]
  },
  "amplify": {
    "userPoolId": "us-east-1_nY154N4yV",
    "userPoolWebClientId": "7iapvj75crn79593bjgphgfdog",
    "oauth": {
      "domain": "atlas-auth-test.mit.edu",
      "scope": [
        "digital-id/search",
        "digital-id/user",
        "openid",
        "profile",
        "voip/user"
      ],
      "redirectUris": [
        "https://voip-v2-test.atlas-apps-test.mit.edu"
      ],
      "postLogoutRedirectUris": [
        "https://voip-v2-test.atlas-apps-test.mit.edu/logout"
      ],
      "responseType": "token",
      "options": {
        "AdvancedSecurityDataCollectionFlag": false
      }
    }
  }
};
export default appConfig;